import {InjectionToken} from '@angular/core';
import {II18nService} from './i18n-service.interface';

export const I18N_SERVICE = new InjectionToken<II18nService>(
    'I18N_SERVICE'
);
